/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import 'sal.js/dist/sal.css';
import React, { useEffect } from 'react';
import sal from 'sal.js';
import { render } from 'storyblok-rich-text-react-renderer';

import FluidImage from 'components/fluidImage';

const QuoteBlock = ({ blok }) => {
  useEffect(() => {
    if (blok.animate) {
      sal({ threshold: 0.25 });
    }
  }, [blok.animate]);

  const isAnimate = blok.animate;
  const renderText = render(blok.text);
  const renderCopy = render(blok.copy);

  return (
    <div className="container">
      <div className="grid grid-cols-2 gap-5 py-7 lg:gap-4 lg:py-8 xl:gap-5 xl:gap-y-0 xl:py-10">
        {renderCopy ? (
          <>
            <div
              className="order-0 col-span-2 mb-10 lg:col-span-1 lg:mb-0 lg:mr-auto lg:max-w-[85%] xl:max-w-[75%]"
              {...(isAnimate
                ? {
                    'data-sal': 'slide-up',
                    'data-sal-duration': '1000',
                    'data-sal-delay': '0',
                    'data-sal-easing': 'ease',
                  }
                : {})}
            >
              <div className="prose text-sm  !leading-normal lg:text-lg xl:text-xl">
                {renderCopy}
              </div>
            </div>
            {blok.text && (
              <div
                className="order-2 col-span-2 mb-2 space-y-5 lg:order-none lg:col-span-1 lg:mb-auto lg:ml-auto lg:max-w-[85%] lg:space-y-16 xl:max-w-[75%] xl:space-y-20"
                {...(isAnimate
                  ? {
                      'data-sal': 'slide-up',
                      'data-sal-duration': '1000',
                      'data-sal-delay': '0',
                      'data-sal-easing': 'ease',
                    }
                  : {})}
              >
                <div className="prose pt-2 text-lg lg:pt-0 lg:text-2xl lg:!leading-[1.25] xl:text-3.5xl">
                  {renderText}
                </div>
                {blok.text && <p className="text-sm lg:text-lg xl:text-2xl">{blok.author}</p>}
              </div>
            )}
            {blok.image_full && (
              <div
                className="order-1 col-span-2 w-full lg:order-none"
                {...(isAnimate
                  ? {
                      'data-sal': 'slide-up',
                      'data-sal-duration': '1000',
                      'data-sal-delay': '0',
                      'data-sal-easing': 'ease',
                    }
                  : {})}
              >
                <FluidImage image={blok.image_full} className="w-full" critical={false} />
              </div>
            )}
            {blok.image_right && (
              <div
                className="order-last col-span-1 w-full lg:order-none"
                {...(isAnimate
                  ? {
                      'data-sal': 'slide-up',
                      'data-sal-duration': '1000',
                      'data-sal-delay': '0',
                      'data-sal-easing': 'ease',
                    }
                  : {})}
              >
                <FluidImage image={blok.image_right} className="w-full" critical={false} />
              </div>
            )}
          </>
        ) : (
          <>
            {blok.text && (
              <div
                className="order-last col-span-2 space-y-5 self-end lg:order-none lg:col-span-1 lg:space-y-16 xl:space-y-20"
                {...(isAnimate
                  ? {
                      'data-sal': 'slide-up',
                      'data-sal-duration': '1000',
                      'data-sal-delay': '0',
                      'data-sal-easing': 'ease',
                    }
                  : {})}
              >
                <div className="prose pt-2 text-lg lg:max-w-[80%] lg:pt-0 lg:text-2xl lg:!leading-[1.25] xl:text-3.5xl">
                  {renderText}
                </div>
                {blok.text && <p className="text-sm lg:text-lg xl:text-2xl">{blok.author}</p>}
              </div>
            )}
            {blok.image_left && (
              <div
                className="col-[2] w-full lg:col-span-1 lg:mt-auto"
                {...(isAnimate
                  ? {
                      'data-sal': 'slide-up',
                      'data-sal-duration': '1000',
                      'data-sal-delay': '0',
                      'data-sal-easing': 'ease',
                    }
                  : {})}
              >
                <FluidImage
                  image={blok.image_left}
                  className="aspect-[195/160] w-full lg:aspect-[795/640]"
                  critical={false}
                />
              </div>
            )}
            {blok.image_full && (
              <div
                className="col-span-2 w-full"
                {...(isAnimate
                  ? {
                      'data-sal': 'slide-up',
                      'data-sal-duration': '1000',
                      'data-sal-delay': '0',
                      'data-sal-easing': 'ease',
                    }
                  : {})}
              >
                <FluidImage image={blok.image_full} className="w-full" critical={false} />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default QuoteBlock;

QuoteBlock.propTypes = {
  blok: PropTypes.object.isRequired,
};
